(() => {
  const THRESHOLD = 145; // más alto = usa blanco más seguido (ajústalo)
  const SAMPLE = 24;     // tamaño de muestreo (más bajo = más rápido)

  function avgLuma(img) {
    const canvas = document.createElement("canvas");
    canvas.width = SAMPLE;
    canvas.height = SAMPLE;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, SAMPLE, SAMPLE);

    const { data } = ctx.getImageData(0, 0, SAMPLE, SAMPLE);
    let sum = 0;
    let count = 0;

    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3];
      if (a < 10) continue; // ignora pixeles casi transparentes

      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];

      sum += 0.2126 * r + 0.7152 * g + 0.0722 * b;
      count++;
    }
    return count ? sum / count : 255;
  }

  function applyToSlide(slide) {
    const img =
      slide.querySelector(".slideshow__media img") ||
      slide.querySelector(".banner__media img") ||
      slide.querySelector("img");

    const textWrap =
      slide.querySelector(".slideshow__text-wrapper") ||
      slide.querySelector(".slideshow__text") ||
      slide;

    if (!img || !textWrap) return;

    const run = () => {
      try {
        const luma = avgLuma(img);
        const useWhite = luma < THRESHOLD;

        // Dawn usa mucho rgb(var(--color-foreground)), así que esto afecta títulos + texto
        textWrap.style.setProperty(
          "--color-foreground",
          useWhite ? "255, 255, 255" : "0, 0, 0"
        );

        textWrap.dataset.autoContrast = useWhite ? "light-text" : "dark-text";
      } catch (e) {
        // Fallback si el canvas se “taints” por CORS (raro, pero puede pasar)
        textWrap.style.setProperty("--color-foreground", "255, 255, 255");
        textWrap.dataset.autoContrast = "light-text";
      }
    };

    if (img.complete && img.naturalWidth) run();
    else img.addEventListener("load", run, { once: true });
  }

  function init() {
    document.querySelectorAll(".slideshow").forEach((slideshow) => {
      slideshow.querySelectorAll(".slideshow__slide").forEach(applyToSlide);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
